<template>
  <div class="agree">
    <p class="title item"><strong>隐私政策</strong></p>
    <p>更新日期：2024年07月01日</p>
    <p class="item">生效日期：2024年07月01日</p>
    <p>版本更新提示：</p>
    <p class="item">
      感谢您使用给缘！本次大连亿果网络科技有限公司（下称“我们”或“给缘”）依据《信息安全技术个人信息安全规范》（GB/T
      35273-2020）以及其他相关法律法规和技术规范更新了一些内容，其中主要包括如下内容：根据法律法规和技术规范更新了部分定义；追加了我们获取您权限和相关个人信息的信息。
    </p>
    <p class="item">
      为了更好的保护您的个人信息，建议您仔细阅读更新后的《给缘隐私政策》。如您对本隐私政策条款有任何异议或疑问，您可通过本《给缘隐私政策》第九章节“如何联系我们”中公布的联系方式与我们沟通。
    </p>
    <p class="item">
      当您与我们就取得产品或服务进行联系时，将可能被要求提供部分个人信息
    </p>
    <p>
      我们深知个人信息对您的重要性，也理解您关心您的个人信息是如何被使用的，因此我们制订了本《给缘隐私政策》（以下简称“隐私政策”或“政策”），以阐述我们如何收集、使用及储存您的个人信息，我们将如何保护您的个人信息安全。
    </p>
    <p>我们制定本隐私政策并特别提示您：</p>
    <p>
      <b>【特别提示】</b
      >还请您在使用给缘前，仔细阅读（未成年人请在监护人陪同下阅读）并了解本政策，以做出适当选择。当您同意本隐私政策时，即表示您已同意我们按照本政策处理您的相关信息。如果您不同意本隐私政策，您可以放弃使用我们的产品或服务。
    </p>
    <p>
      一旦您开始使用给缘提供的各项产品或服务，即表示您已充分理解并同意本政策。
    </p>
    <p class="item">本隐私政策将帮助您了解以下内容：</p>
    <p class="">第一章节 我们如何收集和使用您的个人信息</p>
    <p class="">第二章节 我们如何储存您的个人信息</p>
    <p class="">第三章节 我们如何共享、转让、公开披露您的个人信息</p>
    <p class="">第四章节 我们如何保护您的个人信息</p>
    <p class="">第五章节 我们使用Cookie技术的目的及方式</p>
    <p class="">第六章节 您如何管理您的个人信息</p>
    <p class="">第七章节 我们如何处理未成年人的个人信息</p>
    <p class="">第八章节 隐私政策如何更新</p>
    <p class=" item">第九章节 如何联系我们</p>
    <p class="topTitle">第一章节 我们如何收集和使用您的个人信息</p>
    <dl>
      <dt class="bold">一、个人信息范围</dt>
      <dd>
        本隐私政策中涉及的个人信息指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私政策中主要涉及的个人信息包括：<b>基本信息（包括个人姓名、生日、性别、住址、个人电话号码、电子邮箱）；个人身份信息（包括身份证、军官证、护照、驾驶证）；个人形象，声音和画面；网络身份标识信息（包括系统账号、密码、IP地址）；个人财产信息（交易和消费记录以及音符之类虚拟财产信息）；通讯录；个人常用设备信息（包括硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码（包括IMEI/Android
        ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息在内的描述个人常用设备基本情况的信息）；个人位置信息（定位信息）</b>。
      </dd>
      <dt class="bold">二、收集个人信息的业务功能</dt>
      <dd class="item">
        我们根据合法、正当、必要的原则，为实现给缘
        APP下述的各项功能，收集和使用您的个人信息：
      </dd>
      <dd class="item">
        <table>
          <thead>
          <tr>
            <th colspan="5">收集个人信息的业务功能</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>序号</td>
            <td>业务功能</td>
            <td>所涉个人信息/系统权限类型</td>
            <td>收集使用目的</td>
            <td>收集方式</td>
          </tr>
          <tr v-for="item in listData" :key="item.seq">
            <td>{{ item.seq }}</td>
            <td>{{ item.effect }}</td>
            <td>{{ item.type }}</td>
            <td>{{ item.obj }}</td>
            <td>{{ item.mode }}</td>
          </tr>
          </tbody>
        </table>
      </dd>
      <dd>
        2.运营与安全运行：我们致力于为你提供安全、可信的产品与使用环境，提供优质而可靠的服务与信息是我们的核心目标。<b>为了维护相关产品或服务的正常稳定运行，保护你或其他用户或公众的安全及合法利益，我们会收集如下必要信息：</b>
      </dd>
      <dd>
        <p class="para">1.为了保障软件与服务的安全运行、运营的质量及效率，我们会收集你的<b></b>硬件型号、操作系统版本号、设备标识符（Android如IMEI、AndroidID、OAID、IMSI、ICCID、GAID、MEID，iOS如IDFV、IDFA；不同的标识符在有效期、是否可由用户重置以及获取方式方面会有所不同）、网络设备硬件地址（MAC地址）、硬件序列号、IP 地址、WLAN接入点（如SSID，BSSID）、蓝牙（Bluetooth）、基站、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志、传感器信息等数据。</p>
        <p class="para">2.为了预防恶意程序、保障运营质量及效率，我们会收集安装的应用信息或正在运行的进程信息、应用程序的总体运行、使用情况与频率、应用崩溃情况、总体安装使用情况、性能数据、应用来源。以及对平台进行优化升级，我们将收集应用软件运行异常信息。</p>
        <p class="para">3.为实现运行故障报错及分析和解决您在使用软件过程中所遇到的问题，<b>我们将收集您的设备信息（GUID、MAC、IP地址）、浏览和操作记录。</b></p>
        <p class="para">4.为了在服务过程中防止欺诈及保护您的交易安全，我们将收集您的设备位置信息。</p>
        <p class="para">5.我们可能使用你的帐号信息、设备信息、服务日志信息，以及我们的关联方、合作方获得你授权或依法可以提供给我们的信息，如：我们会用到SDK（com.umeng、数美设备指纹等）获取 <b>设备序列号</b>，用于判断帐号安全、交易安全、进行身份验证、识别违法违规情况、检测及防范安全事件，并依法采取必要的记录、分析、处置措施。</p>
<!--        <p class="para">6.App会收集用户的<b>个人信息、访问习惯及设备标识符（Android如IMEI、AndroidID、OAID、IMSI、ICCID、GAID、MEID，iOS如IDFV、IDFA；）</b>，通过定向推送的方式为您展现合适的直播内容和有趣的朋友信息等个性化服务，用户可以通过我的页面-设置-隐私设置-精彩推荐中进行关闭/开启</p>-->
      </dd>
<!--      <dd>-->
<!--        3.应用自启动：我们将在你关闭应用后继续推送您的好友消息，确保您可以第一时间收到信息。-->
<!--      </dd>-->
      <dt class="bold">三、与第三方账号相关的信息收集和使用</dt>
      <dd>
        您可以使用第三方账号（如微信、QQ）登录给缘平台，此时您将授权我们获取您在第三方平台上的<b>公开信息</b>（头像、昵称），并将您的该第三方账号与您的给缘账号绑定，使您可以通过该第三方账号直接登录并使用给缘的产品与服务。完成注册后，您将能够以注册用户身份在给缘平台上使用观看直播、留言评论等功能。为了给您提供更好的服务，并为了预防互联网犯罪，我们的关联公司、合作伙伴可能会（在有法律依据或征得您同意的前提下）向我们分享您的个人信息。我们可能从第三方获取您授权共享的账号信息（头像、昵称），并在您同意本隐私政策后将您的第三方账号与您的账号绑定，使您可以通过第三方账号直接登录并使用我们的产品或服务。我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。
      </dd>
      <dt class="bold">四、拒绝提供个人信息的选项及其可能带来的影响</dt>
      <dd>
        您可以通过给缘APP或给缘平台的网站和其他软件中的选项来设置是否向我们提供某些个人信息，具体设置方法取决于您设置时该等产品的功能与界面设计，您可以咨询我们的客服人员。举例来说，观看直播的用户可以随时通过“我的→设置→消息通知”的控制开关来打开或关闭声音/震动提示。
      </dd>
      <dd>
        <b>您也可以通过您设备的操作系统提供的选项来开启或关闭某些系统权限，从而允许或阻止我们收集您的个人信息，例如 <b>电话、联系人、麦克风、摄像头、内／外部存储空间访问权限。</b>请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现相对应的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能，但不影响您使用其他功能</b>
      </dd>
      <dd>
        若您拒绝向我们提供某些个人信息，给缘APP整体仍然可用，但可能导致您无法正常使用某些功能，具体来说可能造成如下影响：
        <p class="para">
          1.若您拒绝授权电话权限，我们将无法取得您的IMEI等唯一设备识别码，可能无法判定是否存在非法登录（盗号）、自动控制等情形，无法确保保障您的网络与信息安全；
        </p>
        <p class="para">
          2.若您拒绝提供您的地理位置信息，会影响我们对您所处位置的判定，从而影响“附近”等与地理位置有关的功能实现；
        </p>
        <p class="para">
          3.若您拒绝提供银行账号信息和个人身份证件信息，会导致无法完成消费、提现或其他交易；
        </p>
        <p class="para">
          4.若您拒绝提供手机号码、个人身份证件信息和／或生物识别信息（面部特征），会导致我们无法进行实名认证，按照可适用的法律法规，您将不能使用直播开播功能，以及可能无法正常使用内容发布、分享方面的功能。征得授权同意的例外。
        </p>
      </dd>
      <dt class="bold">五、您个人信息使用的规则</dt>
      <dd class="item bold">
        <p class="para">
          1、我们会根据本隐私政策的约定并为实现我们的产品与或服务功能对所收集的个人信息进行使用。
        </p>
        <p class="para">
          2、在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。
        </p>
        <p class="para">
          3、请您注意，您在使用我们的产品与或服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的产品或服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除或匿名化处理您的个人信息。
        </p>
        <p class="para">
          4、我们会对我们的产品与服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与服务的整体使用趋势。但这些统计信息将不包含您的任何个人信息。
        </p>
        <p class="para">
          5、我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全。
        </p>
        <p class="para">
          6、当我们要将您的个人信息用于本政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会通过您主动做出勾选的形式事先征求您的同意，未经您的同意我们将不会使用。
        </p>
        <p class="para">
          7、如我们停止运营给缘产品或服务，我们将及时停止继续收集您个人信息的活动，我们将停止运营的通知以逐一送达或公告的形式通知您，我们将停止使用并删除或匿名化处理您的个人信息。
        </p>
      </dd>
      <dt class="topTitle">第二章节 我们如何存储您的个人信息</dt>
      <dd>
        1、我们在中华人民共和国境内运营中收集和产生的您的个人信息，存储在中国境内。
      </dd>
      <dd class="bold">
        一般而言，我们自您使用服务时获取到您个人信息之日起至您注销账户后<b>6个月内</b>会存储并保留您的个人信息。
      </dd>
      <dd class="bold">
        在您的个人信息超出保留期间后，<b>我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。</b>
      </dd>
      <dd class="item">
        当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。
      </dd>
      <dt class="bold item">
        第三章节 我们如何共享、转让、公开披露您的个人信息
      </dt>
      <dd class="item">
        我们已知晓对外共享、转让、公开披露个人信息所承担的相应法律责任，我们仅会在本隐私政策约定的范围内共享、转让、公开披露您的个人信息：
      </dd>
      <dt class="bold">一、共享</dt>
      <dd class="item">
        我们不会与给缘服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：
        <p>
          1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
        </p>
        <p>
          2、在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。
        </p>
        <p>
          3、与授权合作伙伴共享：<b>我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能</b>，我们仅会出于本隐私权政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到其履行职责所需信息，且不得将此信息用于其他任何目的。
        </p>
        <p>
          目前，我们的授权合作伙伴包括以下类型：<br />
          <span
          >（1）广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息与提供广告、分析服务的合作伙伴共享。我们会委托这些合作伙伴处理与广告覆盖面和有效性相关的信息，但不会提供您的个人身份信息，或者我们将这些信息进行去标识化处理，以便它不会识别您个人。这类合作伙伴可能将上述信息与他们合法获取的其他数据相结合，以执行我们委托的广告服务或决策建议</span
          ><br />
          <span
          >（2）供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。</span
          >
        </p>
        <p class="item">
          4、为了使您能够正常使用服务及功能，我们的应用中会接入第三方SDK,
          <!--<span-->
          <!--@click="gotoThree"-->
          <!--class="blue"-->
          <!--&gt;《第三方SDK目录》</span>-->
          我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私权政策以及其他任何相关的保密和安全措施来处理个人信息。<br />
        </p>
        <table>
          <thead>
          <tr>
            <th class="width20">序号</th>
            <th>第三方</th>
            <th>所涉信息</th>
            <th>用途</th>
            <th>第三方隐私协议政策</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in DeviceData" :key="item.seq">
            <td>{{item.seq}}</td>
            <td>{{item.third}}</td>
            <td>{{item.info}}</td>
            <td>{{item.purpose}}</td>
            <td><a :href="item.agreement" class="blue">{{item.agreement}}</a></td>
          </tr>
          </tbody>
        </table>
      </dd>
      <dt class="bold">二、转让</dt>
      <dd>
        我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：<br />
        <p>
          1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；
        </p>
        <p>
          2、在涉及合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。
        </p>
      </dd>
      <dt class="bold">三、公开披露</dt>
      <dd>
        我们仅会在以下情况下，公开披露您的个人信息：<br />
        <p>
          1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；
        </p>
        <p>
          2、如果我们确定您出现违反法律法规或严重违反给缘相关协议规则的情况，或为保护给缘及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或给缘相关协议规则征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及给缘已对您采取的措施。
        </p>
      </dd>
      <dt class="bold item">
        四、共享、转让、公开披露个人信息时事先征得授权同意的例外
      </dt>
      <dd class="item">
        以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：<br />
        <p>1、与国家安全、国防安全有关的；</p>
        <p>2、与公共安全、公共卫生、重大公共利益有关的；</p>
        <p>
          3、与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；
        </p>
        <p>
          4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
        </p>
        <p>5、您自行向社会公众公开的个人信息；</p>
        <p>
          6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
        </p>
        <p>
          7、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
        </p>
        <p>8、法律法规规定的其他情形。</p>
      </dd>
      <dt class="item bold">
        根据法律规定，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。
      </dt>
      <dt class="topTitle">第四章节 我们如何保护您的个人信息</dt>
      <dd class="item">
        我们非常重视您个人信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护您的个人信息，防止您提供的个人信息被不当使用。<br />
        <p>
          一、我们会使用不低于同行的加密技术、匿名化处理及相关合理可行的手段保护您的个人信息，并使用安全保护机制防止您的个人信息遭到恶意攻击。
        </p>
        <p>
          二、我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。
        </p>
        <p>
          三、给缘平台上提供的直播和其他业务功能中某些具体的模块或功能由外部供应商提供。对我们委托处理个人信息的公司、组织和个人，我们会与其签署严格的保密协议，要求他们按照我们的要求、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。
        </p>
        <p>
          四、互联网并非绝对安全的环境，<b>我们强烈建议您不要使用非给缘推荐的通信方式发送个人信息。</b>您可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的交易内容、联络方式、交流信息或分享内容等相关信息的第三方。
        </p>
      </dd>
      <dt class="topTitle">第五章节 我们使用Cookie技术的目的及方式</dt>
      <dd>
        一、为确保网站正常运转、为您获得更轻松的访问体验，我们会在计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。Cookie是一种网络服务器存储在计算机或移动设备上的纯文本文件。Cookie的内容只能由创建它的服务器检索或读取
      </dd>
      <dd>
        二、我们Cookie的目的与大多数网站或互联网服务提供商启用Cookie的目的一样，即改善用户体验，我们不会将Cookie用于本隐私政策所述目的之外的任何用途。借助于Cookie，网站能够记住用户的单次访问或多次访问。借助于Cookie，网站能够保存设置，例如计算机或移动设备的语言、字体大小和其他浏览偏好。
      </dd>
      <dd class="item">
        三、您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。
      </dd>
      <dt class="topTitle">第六章节 您如何管理您的个人信息</dt>
      <dd class="item">
        您应确保提交的所有个人数据都准确无误，并及时更新这些数据。您可以通过以下方式访问及管理您的个人信息：<br />
        <p>
          <b>一、查询您的个人信息</b><br />
          您有权访问您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问您的个人信息：<br />
          个人信息—如果您希望访问或编辑您个人资料中的昵称、头像、性别以及其他资料的，您可以通过登录账户通过“我的”-“头像”执行此类操作。
        </p>
        <p>
          <b>二、更正您的个人信息</b><br />
          当您发现关于您的个人信息有错误时，您有权要求我们做出更正或补充。您可以通过本章节“一”访问查询您的“个人信息”中列明的方式提出更正或补充申请。
        </p>
        <p>
          <b>三、删除您的个人信息</b><br />
          您可以通过本章节“一”访问查询您的“个人信息”中列明的方式删除您的部分个人信息。在以下情形中，您可以向我们提出删除个人信息的请求：<br />
          1、如果我们处理个人信息的行为违反法律法规；<br />
          2、如果我们收集、使用您的个人信息，却未征得您的明确同意；<br />
          3、如果我们处理个人信息的行为严重违反了与您的约定；<br />
          4、如果您不再使用我们的产品或服务，或您主动注销了账号；<br />
          5、如果我们永久不再为您提供产品或服务。<br />
          <b>
            当您或我们协助您从我们的服务中删除信息后，依据相关法律法规的规定，我们可能不会立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。
          </b>
        </p>
        <p>
          <b>四、个人信息主体注销账户</b><br />
          您可以通过以下方式注销自己的账号：
          1.登录给缘手机客户端，进入“我的”→“设置”→“注销账号”；
          2.按照本政策文末所列明的公开联系方式，联系我们客服微信号：<span class="blue">d17172154717</span>;协助您注销账号。
          在您主动注销账户之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息，或使其匿名化处理。
        </p>
        <p>
          <b>五、用户授权撤回</b><br />
          您可以通过以下途径撤销已同意的授权：<br />
          1、发送邮件至 <a href="milto:shouqingkefu@requjiaoyou.com" class="blue">shouqingkefu@requjiaoyou.com </a><br />
          您申请授权撤回后，给缘将不再处理相应的个人信息。请您理解，因您的授权撤回，我们无法继续为您提供撤回同意或授权所对应的特定功能或/和服务。但您撤回同意的决定，不会影响此前基于您的授权而展开的个人信息处理。
        </p>
        <p>
          <b>六、通过客服响应您的上述请求</b><br/>
          在您无法自行通过账户密码进行操作的情况下，为保障个人信息安全，我们可能会先要求您验证自己的身份，然后再处理您的请求。您可能需要提供书面请求，或以其他方式证明您的身份。
          针对此类请求，我们将在15天个工作日内做出答复。
        </p>
        <p>
          <b>七、在以下情形中，按照法律法规要求，我们将无法响应您的请求</b><br/>
          1、与国家安全、国防安全有关的；<br/>
          2、与公共安全、公共卫生、重大公共利益有关的；<br/>
          3、与犯罪侦查、起诉、审判和执行判决等有关的；<br/>
          4、响应您的请求将使其他个人、组织的合法权益受到严重损害的；<br/>

        </p>
      </dd>
      <dt class="topTitle">第七章节 我们如何处理未成年人的个人信息</dt>
      <dd class="item">
        任何18岁以下的未成年人均不得创建自己的用户账户及/或使用我们的服务。我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或披露未成年人的个人信息。
      </dd>
      <dt class="topTitle">第八章节 本隐私政策如何更新</dt>
      <dd class="item">
        我们的隐私权政策可能变更。<br/>
        未经您明确同意，我们不会限制您按照本隐私权政策所应享有的权利。对于重大变更，我们会提供显著的通知（包括我们会通过给缘公示的方式进行通知甚至向您提供弹窗提示）。<br/>
        本政策所指的重大变更包括但不限于：<br/>
        1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；<br/>
        2、我们在控制权等方面发生重大变化。如并购重组等引起的所有者变更等；<br/>
        3、个人信息共享、转让或公开披露的主要对象发生变化；<br/>
        4、您参与个人信息处理方面的权利及其行使方式发生重大变化；<br/>
        5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；<br/>
        6、个人信息安全影响评估报告表明存在高风险时。<br/>
        我们还会将本隐私权政策的旧版本存档，供您查阅。
      </dd>
      <dt class="topTitle">第九章节 如何联系我们</dt>
      <dd>
        您可以通过以下方式与我们联系，我们将在15个工作日内回复您的请求：<br/>
        1、如果您对本政策内容有任何疑问、意见或建议，您可通过给缘客服微信号,<span class="blue">d17172154717</span>;<br/>
        2、如发现个人信息可能被泄露，您可以发邮件至<a href="mailto:shouqingkefu@requjiaoyou.com" class="blue">shouqingkefu@requjiaoyou.com</a>投诉举报。<br/>
        3、本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本协议产生之争议，均应依照中华人民共和国法律予以处理。<br/>
        4、如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，<b>您还可以通过向被告住所地有管辖权的法院通过起诉途径寻求解决方案。</b>
      </dd>
    </dl>
    <p class="ac pd10">大连亿果网络科技有限公司</p>
    <p class="ac">2022年11月02日</p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      listData: [
        {
          seq: 1,
          effect: "注册／登录给缘账号",
          type: "网络身份标识（账号）、口令区分用户身份",
          obj: "保护用户账号安全",
          mode: "用户自愿输入"
        },
        {
          seq: 2,
          effect: "通过手机号注册／登录给缘账号",
          type: "手机号码",
          obj: "区分用户身份；向用户发送短信验证码",
          mode: "用户自愿输入"
        },
        {
          seq: 3,
          effect: "通过第三方账号注册／登录给缘账号",
          type: "网络身份标识（账号）、头像、昵称、唯一设备识别码",
          obj: "使第三方账号绑定给缘账号",
          mode: "用户自愿输入"
        },
        {
          seq: 4,
          effect: "更换用户头像",
          type: "相机、相册权限",
          obj: "上传个性照片作为给缘账号头像",
          mode: "用户自愿上传、拍摄"
        },
        {
          seq: 5,
          effect: "编辑个人资料",
          type: "性别、生日、昵称、星座、兴趣、签名",
          obj: "丰富个人信息，便于使用社交功能",
          mode: "用户自愿输入"
        },
        {
          seq: 6,
          effect: "用户实名认证",
          type: "真实姓名、身份证件信息、生物识别信息（面部特征）",
          obj: "辨别用户真实身份",
          mode: "用户自愿输入和拍摄"
        },
        {
          seq: 7,
          effect: "上传或发布内容",
          type: "相机、照片、麦克风权限",
          obj: "上传或发布文字、照片、录音、录像",
          mode: "用户自愿上传和发布"
        },
        {
          seq: 8,
          effect: "充值消费",
          type: "网络身份标识（账号）、交易和消费记录、虚拟货币／物品及其交易",
          obj: "支撑用户完成消费",
          mode: "用户自愿操作"
        },
        {
          seq: 9,
          effect: "分享",
          type: "网络身份标识（账号）",
          obj: "允许用户将给缘中的内容分享给他人",
          mode: "自动获取及记录"
        },
        {
          seq: 10,
          effect: "业务埋点",
          type: "用户基本操作信息（点击、打开关闭页面）",
          obj: "根据用户操作信息提供更好的交互",
          mode: "自动获取及记录"
        },
        {
          seq: 11,
          effect: "直播间聊天、私聊",
          type: "网络身份标识（账号）、头像、昵称",
          obj: "用于聊天时展示用户身份",
          mode: "自动获取及记录"
        },
        {
          seq: 12,
          effect: "app内部文件读写",
          type: "读取SD卡文件，将文件存储到SD卡",
          obj: "存储app基础配置，礼物动画缓存，用户保存照片等下载文件",
          mode: "用户自愿开启"
        },
        {
          seq: 13,
          effect: "直播开播",
          type: "生物识别信息(声音特征)/账号/头像/昵称，录音权限",
          obj: "用于直播时录制音频推流",
          mode: "用户自愿开启"
        },
        {
          seq: 14,
          effect: "拨打客服电话",
          type: "拨打电话权限",
          obj: "方便用户拨打客服电话咨询信息",
          mode: "用户自愿开启"
        },
        {
          seq: 15,
          effect: "语音聊天",
          type: "录音权限",
          obj: "用于1V1语音聊天",
          mode: "用户自愿开启"
        },
        {
          seq: 16,
          effect: "国外用户使用",
          type: "国外IP",
          obj: "用户在国外，直接访问国内平台速度慢，我们通过IP代理加速，访问国内的服务器，提升访问速度",
          mode: "自动获取"
        },
        {
          seq: 17,
          effect: "直播三方SDK需要",
          type: "读取电话状态",
          obj: "允许以只读方式访问电话状态，包括当前的电话呼叫状态。SDK会根据当前的呼叫状态，启停音频设备，避免占用通话麦克风",
          mode: "自动获取"
        },
        {
          seq: 18,
          effect: "电话拨入、拨出状态",
          type: "查看拨号权限",
          obj: "主播直播过程中电话状态停止推流保护主播隐私",
          mode: "自动获取"
        },
        {
          seq: 19,
          effect: "判断app运行环境",
          type: "系统版本、IP地址、浏览器类型、语言和地区设置、日期和时间、软硬件特征信息",
          obj: "判断当前所处环境是否正常、安全，保证程序正确运行",
          mode: "自动获取及记录"
        },
        {
          seq: 20,
          effect: "下载及安装软件（包括本app的更新）",
          type: "系统版本、IP地址、浏览器类型、语言和地区设置、日期和时间、软硬件特征信息",
          obj: "判断当前所处环境是否正常、安全，保证程序正确运行",
          mode: "自动获取及记录"
        },
        {
          seq: 21,
          effect: "提供基本服务，保存日志和排障信息",
          type: "内部／外部存储空间",
          obj: "监控并记录程序是否正常运行，确保万一发生程序崩溃时收集到足够的排障信息",
          mode: "自动获取及记录"
        },
        {
          seq: 22,
          effect: "视频通话",
          type: "相册、麦克风权限",
          obj: "用于1V1视频聊天",
          mode: "用户自愿拍摄"
        },
        {
          seq: 23,
          effect: "应用自启动",
          type: "APP自启动",
          obj: "为用户提供更便捷、更优质的服务，提升用户的体验，保证用户能及时、稳定的收到好友的消息/直播间/动态推送等",
          mode: "自动获取"
        },
        {
          seq: 24,
          effect: "真人认证",
          type: "相机权限、生物识别信息（面部特征）",
          obj: "丰富个人信息，保证交友的真实度",
          mode: "用户自愿拍摄"
        },
        {
          seq: 25,
          effect: "运行中的进程",
          type: "APP处于后台/手机屏幕关闭后，后台正常运行",
          obj: "使用户可以正常接收到直播间和视频通话的声音",
          mode: "自动获取"
        }
      ],
      DeviceData: [
        {
          seq: 1,
          third: "QQ",
          info: "设备标识符（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM 卡 IMSI 信息），网络访问，获取WiFi状态，写入外部存储",
          purpose:"实现QQ登录、qq分享功能",
          agreement:"https://privacy.qq.com/"
        },
        {
          seq: 2,
          third: "闪验 SDK / ShanYanSDK创蓝",
          info: "为了实现网关取号技术，闪验SDK 需要获取本机号码、设备标识符（包括IDFV、OAID、MAC）、设备硬件信息（包括设备型号、设备硬件制造商）、操作系统信息（包括操作系统版本）、网络信息（包括网络类型、运营商名称、网络状态、网络制式）、SIM卡信息（包括SIM卡状态、subId）、应用信息（包括BundleId、包名、包签名）",
          purpose:"为APP 用户提供一键登录、号码验证、安全校验服务",
          agreement:"https://doc.chuanglan.com/document/T98GE1KYCZDMJDHN"
        },
        {
          seq: 3,
          third: "中国移动",
          info: "设备标识符（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM 卡 IMSI 信息），网络访问，获取WiFi状态，手机号码，应用列表信息",
          purpose:"实现“一键登录”功能",
          agreement:"https://wap.cmpassport.com/resources/html/contract.html"
        },
        {
          seq: 4,
          third: "天翼",
          info: "设备标识符（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM 卡 IMSI 信息），网络访问，获取WiFi状态，手机号码",
          purpose:"实现“一键登录”功能",
          agreement:"https://e.189.cn/sdk/agreement/show.do?order=2&type=main&appKey=&hidetop=true&returnUrl="
        },
        {
          seq: 5,
          third: "中国联通",
          info: "设备标识符（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM 卡 IMSI 信息），网络访问，获取WiFi状态，手机号码",
          purpose:"实现“一键登录”功能",
          agreement:"https://opencloud.wostore.cn/authz/resource/html/disclaimer.html"
        },
        {
          seq: 6,
          third: "支付宝",
          info: "常用设备信息（如IMEI/IMSI、SIM卡序列号/MAC地址、android_id）、网络信息以及地理位置信息，应用列表信息",
          purpose:"唤起支付宝app完成支付",
          agreement:"https://render.alipay.com/p/c/k2cx0tg8"
        },
        {
          seq: 7,
          third: "微信",
          info: "设备标识符（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM 卡 IMSI 信息），网络访问，获取WiFi状态，写入外部存",
          purpose:"实现微信登录、微信分享、微信支付功能",
          agreement:"https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy"
        },
        {
          seq: 8,
          third: "腾讯bugly",
          info: "腾讯bugly	电话状态，读写器外部存储，网络访问，wifi状态访问，获取系统安装的应用程序",
          purpose:"提供应用崩溃信息采集功能",
          agreement:"https://bugly.qq.com/v2/contract"
        },
        {
          seq: 9,
          third: "友盟",
          info: "设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID/SN）、应用信息（应用崩溃信息、通知开关状态、软件列表相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息）、网络信息",
          purpose:"用于统计日活、次留、终端信息分布等信息",
          agreement:"https://www.umeng.com/policy"
        },
        {
          seq: 10,
          third: "极光推送（cn.jpush.android）",
          info: "设备标识符（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM 卡 IMSI 信息）、应用信息（应用崩溃信息、通知开关状态、软件列表相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息）、位置信息、网络信息",
          purpose:"提供消息推送和通知功能",
          agreement:"https://www.jiguang.cn/license/privacy"
        },
        {
          seq: 11,
          third: "Zego",
          info: "录音麦克风权限，摄像头权限，电话状态，wifi状态访问，网络状态，运营商信息，蓝牙访问，网络访问，修改音频设置，读写外部存储，获取系统安装的应用程序，保持设备唤醒",
          purpose:"提供实时音视频云服务",
          agreement:"https://www.zego.im/privacy/"
        },
        {
          seq: 12,
          third: "七牛SDK",
          info: "网络访问，读写外部存储",
          purpose:"用于播放CDN音频",
          agreement:"https://www.qiniu.com/privacy-right"
        },
        {
          seq: 13,
          third: "依图",
          info: "用户声音信息",
          purpose:"提供语音识别功能",
          agreement:"https://www.faceunity.com/policy.html"
        },
        {
          seq: 14,
          third: "声网",
          info: "录音麦克风权限，摄像头权限，电话状态，wifi状态访问，网络状态，运营商信息，蓝牙访问，网络访问，修改音频设置，读写外部存储，获取系统安装的应用程序，保持设备唤醒",
          purpose:"直播推流",
          agreement:"https://www.agora.io/cn/privacy-policy/"
        },
        {
          seq: 15,
          third: "IShumei、数美SmAntiFraud、数美、数美反作弊",
          info: "Android ID、定位权限，电话状态，读写器外部存储，网络访问，wifi状态访问，内置传感器信息，设备信息，获取系统安装的应用程序，获取IMEI信息，获取IMSI信息，获取MAC，获取陀螺仪传感器，加速度传感器",
          purpose:"提供黑产检测功能",
          agreement:"https://www.ishumei.com/legal/cn/privacy.html"
        },
        {
          seq: 16,
          third: "融云",
          info: "录音麦克风权限，摄像头权限，相机相册权限，电话状态，wifi状态访问，网络状态，网络访问，修改音频设置，读写外部存储，获取系统安装的应用程序，保持设备唤醒",
          purpose:"提供单人IM聊天、语音通话、多人聊天功能",
          agreement:"https://www.rongcloud.cn/privacy"
        },
        {
          seq: 17,
          third: "TrackingIO",
          info: "设备信息，运营商信息，访问网络状态，内置传感器信息",
          purpose:"用于App推广效果监测、广告防作弊功能",
          agreement:"https://new.trackingio.com/#/policy"
        },
        {
          seq: 18,
          third: "Udesk",
          info: "录音麦克风权限，摄像头权限，相机相册权限，收集SDK版本号，屏幕尺寸，运营商，设备型号，手机操作系统版本号，App名称，App版本，时间戳，时区和网络	提供在线客服功能",
          purpose:"提供在线客服功能",
          agreement:"https://www.udesk.cn/terms_service.html"
        },
        {
          seq: 19,
          third: "数盟",
          info: "设备信息，运营商信息，访问网络状态，内置传感器信息",
          purpose:"用于App推广效果监测、广告防作弊功能",
          agreement:"https://www.shuzilm.cn/privacy.html"
        },
        {
          seq: 20,
          third: "商汤科技",
          info: "收集SDK版本号，屏幕尺寸",
          purpose:"提供视频美颜功能",
          agreement:"https://www.sensetime.com/cn/clause"
        },
        {
          seq: 21,
          third: "高德地图",
          info: "定位/后台定位/存储",
          purpose:"为了给应用返回用户位置信息，并供开发者基于用户的位置信息提供相应服务；为了便于提供实时路况和路况预测服务，我们会对用户的位置信息进行数据统计和分析，并基于此对交通拥堵状况作判断",
          agreement:"https://lbs.amap.com/pages/privacy/"
        },
        {
          seq: 22,
          third: "百度语音",
          info: "设备信息（即WIFI状态）/设备信息（包括设备型号、操作系统）/音频数据",
          purpose:"为了帮助开发者向最终用户提供功能/服务，同时为了更准确定位并解决开发者以及最终用户在使用语音识别SDK产品和服务时遇到的问题",
          agreement:"https://ai.baidu.com/ai-doc/REFERENCE/Ckdym0tc9"
        },
        {
          seq: 23,
          third: "uc啄木鸟",
          info: "设备标识符（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM 卡 IMSI 信息）、应用信息（应用崩溃信息、通知开关状态、软件列表相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息）、网络信息",
          purpose:"为了收集app中崩溃收集，生成的日志用来分析数据",
          agreement:"http://open-uc.uc.cn/agreement/secret"
        },
        {
          seq: 24,
          third: "银联支付",
          info: "常用设备信息（如IMEI/IMSI、SIM卡序列号/MAC地址、android_id）、网络信息以及地理位置信息，应用列表信息",
          purpose:"实现银联支付功能",
          agreement:"https://www.chinaums.com/chinaums/dsfdy/qmfapplb/201708/t20170828_25547.shtml"
        },
        {
          seq: 25,
          third: "阿里云真人认证&实名认证",
          info: "面部特征信息、身份证号码、姓名",
          purpose:"为用户提供真人认证、实名认证服务",
          agreement:"https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112131013_69952.html?spm=a2c4g.11186623.0.0.2aa876c81rAzX5"
        },
        {
          seq: 26,
          third: "oppo推送",
          info: "设备信息（如IMEI或OAID，Serial Number，IMSI，User ID，Android ID，Google Advertising ID, 手机Region设置，设备型号，手机电量，手机操作系统版本及语言）、使用推送服务的应用信息（如APP包名及版本号，运行状态）、推送SDK版本号、网络相关信息（如IP或域名连接结果，当前网络类型）、消息发送结果、通知栏状态（如通知栏权限、用户点击行为），锁屏状态（如是否锁屏，是否允许锁屏通知）。 ",
          purpose:"提供消息推送和通知功能",
          agreement:"https://open.oppomobile.com/new/developmentDoc/info?id=10288"
        },
        {
          seq: 27,
          third: "vivo推送",
          info: "设备及应用信息：包括您使用vivo设备及服务过程中的操作系统版本号、应用程序信息（包括应用安装列表）、设备标识符（如IMEI、ICCID 、EMMCID/UFSID 、oaid/vaid/aaid 、SN码 和 IMSI、android id、移动国家码和vivo Android设备的移动网号）、MAC地址、移动运营商、使用语言、系统设置系统、设备和应用程序数据。 ",
          purpose:"提供消息推送和通知功能",
          agreement:"https://www.vivo.com.cn/about-vivo/privacy-policy"
        },
        {
          seq: 28,
          third: "小米推送",
          info: "收集设备相关信息如设备厂商、设备型号、设备内存、操作系统版本、小米推送SDK版本、设备归属地（国家或地区）、SIM卡运营商名称、当前网络类型。其中当前网络类型、SIM卡运营商名称仅在设备本地读取，不会上传至小米服务器;收集您的设备标识OAID和加密的Android ID，以及使用推送服务的应用信息如应用包名、版本号和运行状态； ",
          purpose:"提供消息推送和通知功能",
          agreement:"https://dev.mi.com/console/doc/detail?pId=1822"
        },
        {
          seq: 29,
          third: "华为推送",
          info: "设备信息（OAID IMEI MAC AndroiID IDFA）;WIFI信息;SIM卡信息SIM卡状态、SIM卡序列号",
          purpose:"提供消息推送和通知功能",
          agreement:"https://consumer.huawei.com/cn/privacy/privacy-policy/"
        },
        {
          seq: 30,
          third: "相芯科技",
          info: " IP 地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息、用户标识符及网页浏览记录",
          purpose:"提供美颜持续服务和保证服务质量",
          agreement:"https://www.faceunity.com/policy.html"
        },
        {
          seq: 31,
          third: "网易七鱼SDK",
          info: "采集网络信息（网络状态、wifi信息，IP地址），用于了解设备的网络状态和变化，从而最大程度保持网络连接的稳定性；当开启传感器信息权限后，会收集距离传感器信息，用于感知手机是否被举耳边，提供更好的语音聊天体验。",
          purpose:"获取设备",
          agreement:"https://qi.163.com/termsService?privacy=1"
        },
        {
          seq: 32,
          third: "网易易盾",
          info: "设备唯一识别码（设备序列号、MEID、IDFV）、设备品牌、设备名称、设备型号及设备系统类型、详细设置及版本信息判定设备是否处于异常状态",
          purpose:"获取设备信息",
          agreement:"http://dun.163.com/clause/privacy"
        },
        {
          seq: 33,
          third: "移动安全联盟;MSA",
          info: "App包名及签名信息，或在对应应用商店的APPID，生成VAID时判断是否为同一开发者",
          purpose:"获取设备信息",
          agreement:"http://www.msa-alliance.cn/col.jsp?id=122"
        },
        {
          seq: 34,
          third: "okhttp3",
          info: "获取设备信息用于防作弊检测",
          purpose:"获取Android ID",
          agreement:"https://square.github.io/okhttp/"
        },
        {
          seq: 35,
          third: "阿里设备标识SDK(TaobaoUtdid、阿里云Utdid)",
          info: "进行用户身份识别验证并且实现网络链路的选择和优化，以提升用户体验。本SDK会在静默状态下进行收集IMSI、DEVICEID用于保障产品功能的实现与安全稳定运行。",
          purpose:"IMEl、MAC、Android ID、DEVICEID、IDFA、OpenUDID、GUID、SIM卡、IMSI、IP、地理位置、当前运行应用进程及包名、完全的网络访问权限",
          agreement:"https://opendocs.alipay.com/common/067k4b"
        }
      ]
    }
  },
  methods: {
    gotoThree() {
      this.$router.push('/sdkprivacy')
    }
  }
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}
th,
td {
  border: 1px solid #333; //配合border-collapse 设置单边框
  text-align: center;
}
.blue {
  color: blue;
}
.agree {
  line-height: 1.5;
  padding: 10px;
  font-size: 12px;
}
.bold {
  font-weight: 700;
  margin: 10px 5px;
}
.topTitle{
  font-weight: 700;
  margin: 20px 0;
}
.title {
  text-align: center;
  font-size: 14px;
}
.para {
  text-indent: 2em;
}
.item {
  margin-bottom: 10px;
}
.para-s {
  text-indent: 4em;
}
p.ac{
  &.pd10{
    padding-top: 10px;
  }
  text-align: center;
  margin-bottom: 10px;
}
</style>
<style lang="scss" scoped src="../../assets/sass/agreement/agreement.scss"></style>



// WEBPACK FOOTER //
// src/views/index/privacy.vue